import Swiper, { Navigation } from 'swiper';

export default function initGallery() {
  const gallery = document.querySelectorAll('.gallery');
  if (!gallery) return;

  gallery.forEach((el) => {
    const slider = el.querySelector('.swiper');
    const arrowNext = el.querySelector('.swiper-button-next');
    const arrowPrev = el.querySelector('.swiper-button-prev');

    const swiper = new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: arrowNext,
        prevEl: arrowPrev
      }
    });
    swiper.init();
  });
}
